export default "__VITE_ASSET__BKHYirxK__"